type ServiceType = 'eat_in' | 'takeaway';

export const shouldApplyItemFeeByServiceType = (item: { serviceTypes: ServiceType[] }, isTakeAway: boolean) => {
  const serviceType = isTakeAway ? 'takeaway' : 'eat_in';
  return !item.serviceTypes || item.serviceTypes === null || item.serviceTypes?.includes(serviceType);
};
